<template>
  <router-link :to="{ name: $routes.PROFILE, params: { id: userId } }" class="font-weight-bold">
    <slot />
  </router-link>
</template>

<script>
export default {
  props: {
    userId: {
      type: Number,
      default: undefined
    }
  }
}
</script>
